import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/unymobility.webp';
import screenshot_target from '../../../images/letterfunnel/eduardanghel.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Eduard Anghel"
      firstname="Eduard"
      companyname="Uny Mobility"
      competition="Wize Power en SWAP Energy"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/eduardanghel.js